<template>
  <div class="goods_index">
    <el-breadcrumb separator="/" slot="breadcrumb" class="breadcrumb-bg">
      <el-breadcrumb-item :to="{ path: '/admin' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ name: 'agent_index' }">我的采购单</el-breadcrumb-item>
    </el-breadcrumb>

    <div class="title"><span class="el-icon-notebook-2"></span>订单详细</div>
    <el-card>
      <div>{{ result.data.oid }} 下单日期:{{ formatGMT(result.data.created_time) }}</div>
      <div
        v-for="(v, index) in result.data.order_info"
        :key="index"
        class="order_content"
      >
        <el-row>
          <el-col> 款号：{{ v.title }}</el-col>
        </el-row>
        <el-row>
          <el-col> 属性: {{ v.color_label }}{{ v.size_label }} </el-col>
        </el-row>
      </div>
    </el-card>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  data() {
    return {
      multipleSelection: [],
      dialogFormVisible: false,
      dialogStoreVisible: false,

      dialog_restore_visible: false,
      oid: 0,
    };
  },
  methods: {
    ...mapActions({
      getOrderProfitsDetailAction: "getOrderProfitsDetailAction",
    }),
    formatGMT(gmt, long) {
      long = false === long ? false : true;
      let date = new Date(gmt);

      let m = date.getMonth() + 1,
        mm = "-" + (m < 10 ? "0" + m : m);
      let d = date.getDate(),
        dd = "-" + (d < 10 ? "0" + d : d);
      let h = date.getHours(),
        hh = " " + (h < 10 ? "0" + h : h);
      let i = date.getMinutes(),
        ii = ":" + (i < 10 ? "0" + i : i);
      let s = date.getSeconds(),
        ss = ":" + (s < 10 ? "0" + s : s);

      return date.getFullYear() + mm + dd + (long ? hh + ii + ss : "");
    },
  },
  created() {
    this.oid = this.$route.params.oid;

    this.getOrderProfitsDetailAction({ oid: this.oid });
  },
  //tableData
  computed: mapState({
    result: (state) => state.order_profits.result,
  }),
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.dialog-footer {
  text-align: center;
  background-color: gainsboro;
  padding: 0.3rem;
}
</style>
